import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
var ValueLabelComponent = React.memo(function (props) {
    var children = props.children, open = props.open, value = props.value;
    return (React.createElement(Tooltip, { open: open, enterTouchDelay: 0, TransitionComponent: function (props) { return props.children; }, placement: "top", title: value }, children));
});
var Keyboard = function (props) {
    var _a = React.useState([parseInt(props.bpmMin) || 0, parseInt(props.bpmMax) || 200]), value = _a[0], setValue = _a[1];
    React.useEffect(function () {
        setValue([parseInt(props.bpmMin) || 0, parseInt(props.bpmMax) || 200]);
    }, [props.bpmMax, props.bpmMin]);
    var highlightKeyType = function (e, keyType) {
        if (props.onKeyTypeChange) {
            e.stopPropagation();
            props.onKeyTypeChange(keyType);
        }
    };
    var key = props.selectedKey;
    var isMinor = false;
    var isMajor = false;
    if (key) {
        if (key.endsWith('min')) {
            key = key.slice(0, -3).trim();
            isMinor = true;
        }
        else if (key.endsWith('maj')) {
            key = key.slice(0, -3).trim();
            isMajor = true;
        }
        if (key.endsWith('#')) {
            switch (key.substr(0, 1).toLowerCase()) {
                case 'g':
                    key = 'Ab';
                    break;
                default:
                    key = String.fromCharCode(key.charCodeAt(0) + 1).toUpperCase() + 'b';
            }
        }
    }
    var highlightKey = function (e, key) {
        if (key && (isMajor || isMinor) && !key.includes(' ')) {
            if (isMajor) {
                key += ' maj';
            }
            else {
                key += ' min';
            }
        }
        if (props.onKeyChange) {
            e.stopPropagation();
            props.onKeyChange(key || undefined);
        }
    };
    return (React.createElement("div", { className: "keyboard no-select" },
        React.createElement("div", { className: "top-container" },
            React.createElement("div", { className: "flats " + (props.keyType === 'flats' || props.keyType == undefined ? 'selected' : ''), onClick: function (e) { return highlightKeyType(e, 'flats'); } },
                React.createElement("span", null, "Flats")),
            React.createElement("div", { className: "underline-highlight flats " + (props.keyType === 'flats' || props.keyType == undefined ? 'selected' : '') }),
            React.createElement("div", { className: "sharps " + (props.keyType === 'sharps' ? 'selected' : ''), onClick: function (e) { return highlightKeyType(e, 'sharps'); } },
                React.createElement("span", null, "Sharps")),
            React.createElement("div", { className: "underline-highlight sharps " + (props.keyType === 'sharps' || props.keyType == undefined ? 'selected' : '') }),
            React.createElement("span", { className: "major " + (isMajor ? 'selected' : ''), onClick: function (e) {
                    highlightKey(e, isMajor ? key : ((key || '') + ' maj'));
                } }, "Major"),
            React.createElement("div", { className: "underline-highlight major " + (isMajor ? 'selected' : '') }),
            React.createElement("div", { className: "divider-line" }),
            React.createElement("span", { className: "minor " + (isMinor ? 'selected' : ''), onClick: function (e) {
                    highlightKey(e, isMinor ? key : ((key || '') + ' min'));
                } }, "Minor"),
            React.createElement("div", { className: "underline-highlight minor " + (isMinor ? 'selected' : '') })),
        React.createElement("div", { className: "divider" }),
        React.createElement("div", { className: "keyboard-container" },
            React.createElement("div", { className: "keys" },
                React.createElement("div", { className: "key " + (key === 'C' ? 'highlight' : null), onClick: function (e) { return highlightKey(e, 'C'); } },
                    React.createElement("div", { className: "minor-key " + (key === 'Db' ? 'highlight-minor' : null), onClick: function (e) { return highlightKey(e, 'Db'); } },
                        props.keyType === 'sharps' && React.createElement("span", { className: "minor-text" }, "C#"),
                        props.keyType === 'flats' && React.createElement("span", { className: "minor-text" }, "Db")),
                    React.createElement("span", { className: "letter" }, "C")),
                React.createElement("div", { className: "key " + (key === 'D' ? 'highlight' : null), onClick: function (e) { return highlightKey(e, 'D'); } },
                    React.createElement("div", { className: "minor-key " + (key === 'Eb' ? 'highlight-minor' : null), onClick: function (e) { return highlightKey(e, 'Eb'); } },
                        props.keyType === 'sharps' && React.createElement("span", { className: "minor-text" }, "D#"),
                        props.keyType === 'flats' && React.createElement("span", { className: "minor-text" }, "Eb")),
                    React.createElement("span", { className: "letter" }, "D")),
                React.createElement("div", { className: "key " + (key === 'E' ? 'highlight' : null), onClick: function (e) { return highlightKey(e, 'E'); } },
                    React.createElement("span", { className: "letter" }, "E")),
                React.createElement("div", { className: "key " + (key === 'F' ? 'highlight' : null), onClick: function (e) { return highlightKey(e, 'F'); } },
                    React.createElement("div", { className: "minor-key " + (key === 'Gb' ? 'highlight-minor' : null), onClick: function (e) { return highlightKey(e, 'Gb'); } },
                        props.keyType === 'sharps' && React.createElement("span", { className: "minor-text" }, "F#"),
                        props.keyType === 'flats' && React.createElement("span", { className: "minor-text" }, "Gb")),
                    React.createElement("span", { className: "letter" }, "F")),
                React.createElement("div", { className: "key " + (key === 'G' ? 'highlight' : null), onClick: function (e) { return highlightKey(e, 'G'); } },
                    React.createElement("div", { className: "minor-key " + (key === 'Ab' ? 'highlight-minor' : null), onClick: function (e) { return highlightKey(e, 'Ab'); } },
                        props.keyType === 'sharps' && React.createElement("span", { className: "minor-text" }, "G#"),
                        props.keyType === 'flats' && React.createElement("span", { className: "minor-text" }, "Ab")),
                    React.createElement("span", { className: "letter" }, "G")),
                React.createElement("div", { className: "key " + (key === 'A' ? 'highlight' : null), onClick: function (e) { return highlightKey(e, 'A'); } },
                    React.createElement("div", { className: "minor-key " + (key === 'Bb' ? 'highlight-minor' : null), onClick: function (e) { return highlightKey(e, 'Bb'); } },
                        props.keyType === 'sharps' && React.createElement("span", { className: "minor-text" }, "A#"),
                        props.keyType === 'flats' && React.createElement("span", { className: "minor-text" }, "Bb")),
                    React.createElement("span", { className: "letter" }, "A")),
                React.createElement("div", { className: "key " + (key === 'B' ? 'highlight' : null), onClick: function (e) { return highlightKey(e, 'B'); } },
                    React.createElement("span", { className: "letter" }, "B"))))));
};
export default Keyboard;
//# sourceMappingURL=Keyboard.js.map